<app-header (clickMenuButton)="clickMenuButton()" [showCloseButton]="sidebarOpened && sidebarFixed"
    [isDesktop]="deviceDesktop"></app-header>

<mat-sidenav-container class="full-height" [autosize]="sidebarFixed">
    <mat-sidenav #sidenavRef
        [ngClass]="{'show' : deviceDesktop, 'hide': !deviceDesktop, 'menuMobile' : sidebarOpened && !deviceDesktop}"
        [style.width]="!sidebarOpened && deviceDesktop ? '73px' : '265px'" mode="side" opened>
        <mat-tree id="systemScreens" class="center-tree" [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node style="display: none;" *matTreeNodeDef="let node; when: !showNode">
                <!-- Hidden node. -->
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node;when: showNode" matTreeNodePadding>
                <!-- use a disabled button to provide padding for tree leaf -->
                <a *ngIf="!node.nameIcon.includes('logout')" [routerLink]="node.url" id="{{node.id}}" [attr.data-test]="node.dataTest || null"
                    (click)="hideSidebar()"
                    [ngClass]="{'item-activated' : urlCurrentPage.includes(node.url), 'url-not-activated' : !urlCurrentPage.includes(node.url)}">
                    <i [class]="node.classIcon" class="margin-icons notranslate">{{node.nameIcon}}</i>
                    <span class="cursor-pointer" [hidden]="!sidebarOpened">
                        {{node.name}}
                    </span>
                </a>
                <mat-button *ngIf="node.nameIcon.includes('logout')"
                    [style.width]="!deviceDesktop ? '100%' : !sidebarOpened && deviceDesktop ? '72px' : '240px'"
                    class="item-activated url-not-activated" (click)="logout()" id="{{node.id}}" [attr.data-test]="node.dataTest || null">
                    <i [class]="node.classIcon" class="margin-icons notranslate">{{node.nameIcon}}</i>
                    <span class="cursor-pointer" [hidden]="!sidebarOpened">
                        {{node.name}}
                    </span>
                </mat-button>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node [attr.data-test]="node.dataTest || null" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <mat-button class="contents cursor-pointer" matTreeNodeToggle (click)="sidebarOpened = true"
                    [ngClass]="{'item-activated' : urlCurrentPage.includes(node.url), 'url-not-activated' :  !urlCurrentPage.includes(node.url)}">
                    <i [class]="node.classIcon" class="margin-icons notranslate">{{node.nameIcon}}</i>
                    <span class="cursor-pointer" [hidden]="!sidebarOpened">{{node.name}}</span>
                    <div class="icon-div">
                        <mat-icon class="mat-icon-rtl-mirror" *ngIf="sidebarOpened">
                            {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                        </mat-icon>
                    </div>
                </mat-button>
            </mat-tree-node>
        </mat-tree>
    </mat-sidenav>
    <router-outlet *ngIf="permissoesProntas"></router-outlet>

    <!-- Carregando as permissões, ou falha ao carregar (sem telas protegidas) -->
    <div class="permissions-state" *ngIf="!permissoesProntas">
        <ng-container *ngIf="falhaAoCarregarPermissoes$ | async; else carregandoPermissoes">
            <p class="permissions-error">{{ 'accessApproval.permissionsLoadError' | translate }}</p>
            <div class="permissions-actions">
                <button mat-raised-button color="primary" type="button" (click)="tentarCarregarPermissoesNovamente()">{{ 'accessApproval.retry' | translate }}</button>
                <button mat-stroked-button color="primary" type="button" (click)="logout()">{{ 'accessApproval.exit' | translate }}</button>
            </div>
        </ng-container>
        <ng-template #carregandoPermissoes>
            <mat-spinner diameter="40"></mat-spinner>
        </ng-template>
    </div>
</mat-sidenav-container>
